export const config = {
    maxFPS: 60,
    timeline: {
        entering: 1500,
        starting: 3000,
        charging: 700,
        boosting: 600,
        ending: 100,
    },
    mask: {
        reverse: true,
    },
    bloom: {
        enable: false,
        threshold: 1,
        strength: 1.5,
        radius: 0.4,
    },
    lut: {
        enable: false,
    },
    suction: {
        enable: true,
        strength: 5,
    },
    camera: {
        near: 0.1,
        far: 1000,
        fov: 90,
        rotateY: 20,
        pos: {
            x: 10,
            y: 0,
            z: 1500,
        },
    },
    lines: {
        count: 700,
        baseSpeed: 0.2,
        defaultWidth: 2,
        defaultLength: 65,
        randomDirection: 0.1,
        radius: 60,
        radiusRandomRange: 20,
        sizeChances: {
            thin: 6,
            medium: 2,
            thick: 4,
        },
    },
    rings: {
        speed: 1,
        count: 5,
        size: 400,
        strokeWidth: 1.5,
    },
    instancing: true,

    // ---------OTHER CONFIGS---------
    pxToWorld: 0.2,
    enteringOffset: 500,
};

export const getFullTimelineLength = () => {
    return Object.values(config.timeline).reduce((a, b) => a + b, 0);
};

export const getPhrasesInPercent = () => {
    const fullLength = getFullTimelineLength();
    const entering = config.timeline.entering / fullLength;
    const starting = entering + config.timeline.starting / fullLength;
    const charging = starting + config.timeline.charging / fullLength;
    const boosting = charging + config.timeline.boosting / fullLength;

    return {
        entering,
        starting,
        charging,
        boosting,
        ending: 1,
    };
};
